module.exports = {
      id: "vk-logo-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "static/sprite-tB2AcLEvMStiZiT8pkVL0.svg#vk-logo-usage",
      toString: function () {
        return this.url;
      }
    }